module.exports = __webpack_public_path__ + "img/emp-invite-request-access-btn.4b3a8ba2.webp";